import { useMemo } from 'react';

export function mapToOptions(list, useItem, nullText, base = 0) {
	let allItems = list.map((item, i) => {
		return { key: i, text: item, value: useItem ? item : (i + (base)) };
	});
	
	if (nullText) {
		return [{ key: -1, text: nullText, value: null }, ...allItems];
	} else {
		return allItems;
	}
}

export function useMapToOptions(list, useItem, nullText, base = 0) {
	return useMemo(() => mapToOptions(list, useItem, nullText, base), [nullText, list, useItem, base]);
}

export function range(start, end) {
	return Array(end - start + 1)
		.fill()
		.map((_, idx) => start + idx);
}
